import React, { useState, useEffect } from 'react';
import StickyFooter from 'react-sticky-footer';
import { createMuiTheme, Hidden, Card } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import logo from './img/logo.png';
import './App.css';
import Profile from './components/Profile';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Nav from './components/Nav';
import Web3 from 'web3';
import Fortmatic from 'fortmatic';
import Box from '3box';
import About from './components/about';
import Swiper from './components/Swiper';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#673ab7' },
    secondary: { main: '#50fa7b' },
  },
});

const spaceName = 'dappr';
const fm = new Fortmatic('pk_test_7D071AAA057B504C');

function App() {
  const [theBox, setBox] = useState(null);
  const [theSpace, setSpace] = useState(null);
  const [myAddress, setMyAddress] = useState(null);
  useEffect(() => {
    (async () => {
      // Post EIP-1102 update which MetaMask no longer injects web3
      if (window.ethereum) {
        // Use MetaMask provider
        window.web3 = new Web3(window.ethereum);
      } else if (typeof window.web3 !== 'undefined') {
        window.web3 = new Web3(Web3.currentProvider);
      } else {
        // Use Fortmatic provider
        window.web3 = new Web3(fm.getProvider());
      }

      let addresses = await window.web3.currentProvider.enable();
      setMyAddress(addresses[0]);

      const theBox = await Box.openBox(
        addresses[0],
        window.web3.currentProvider,
      );

      theBox.onSyncDone(() => setBox(theBox));

      const theSpace = await theBox.openSpace(spaceName);
      theSpace.syncDone.then(() => setSpace(theSpace));
    })();
  }, []);
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <div className="App">
          <header className="App-header">
            <img
              src={logo}
              alt="logo"
              height="20%"
              width="25%"
              style={{
                display: 'flex',
                margin: 'auto',
                width: '30%',
              }}
            />
            <Switch>
              <Route exact path="/">
                <div height="20%">
                  <Swiper />{' '}
                </div>
              </Route>
              <Route exact path="/profile">
                <div>
                  <Profile
                    theBox={theBox}
                    theSpace={theSpace}
                    myAddress={myAddress}
                  />
                </div>
              </Route>
              <Route exact path="/about">
                <About />
              </Route>
            </Switch>
          </header>
          <StickyFooter
            bottomThreshold={40}
            normalStyles={{
              backgroundColor: '#999999',
              width: '100%',
            }}
            stickyStyles={{
              backgroundColor: '#999999',
              width: '100%',
            }}
          >
            <Nav />
          </StickyFooter>
        </div>
      </ThemeProvider>
    </Router>
  );
}

export default App;
